var render = function render(){var _vm=this,_c=_vm._self._c;return _c('favorite-action',[_c('primary-action',_vm._g({attrs:{"icon":"sr-2 sr-v2-heart-filled","text":"Favorite"},on:{"click":_vm.onFavorite}},_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }